import { useIntl } from 'react-intl';

import { CtaText } from '@/components/dtcPartnerships/Account/styles';
import BackButton from '@/components/dtcPartnerships/BackButton';
import { ContentWrapper } from '@/components/dtcPartnerships/shared/styles';
import PaymentElementsForm from '@/components/purchase/PaymentElementsForm';
import PurchaseDetails from '@/components/purchase/PurchaseDetails/refreshedPurchaseDetails';
import { useAnalytics } from '@/hooks/analytics/useAnalytics';
import { useGetPurchaseTerms } from '@/hooks/dtcLeadGenPartnership/useGetPurchaseTerms';
import { useComponentDidMount } from '@/hooks/utils/useComponentDidMount';

import { SignupScreenProps } from '../shared/types';
import messages from './messages';
import { GrayLine } from './styles';

const Payment = ({ onScreenChange, partnerDetails, userAccessCode }: SignupScreenProps) => {
	const { formatMessage } = useIntl();

	const { logEvent } = useAnalytics();
	const purchaseTerms = useGetPurchaseTerms(partnerDetails?.offer_details);

	useComponentDidMount(() => {
		logEvent({
			eventName: 'D2C Redemption : Payment : Landed',
			eventProps: {
				is_stripe_next: true,
			},
		});
	});

	const onSuccess = async () => {
		onScreenChange('success');
	};

	return (
		<ContentWrapper>
			<BackButton onScreenChange={onScreenChange} />
			<CtaText>{formatMessage(messages.title)}</CtaText>
			<GrayLine />
			<PurchaseDetails />
			<PaymentElementsForm
				hidePaypal
				hideTerms
				afterPurchaseSuccess={onSuccess}
				endpoint={
					partnerDetails?.id && partnerDetails?.name.toLowerCase() !== 'aarp'
						? `partnerships/${partnerDetails.id}/subscriptions`
						: 'subscription'
				}
				purchaseArgs={
					partnerDetails && partnerDetails.name.toLowerCase() !== 'aarp'
						? {
								partner_id: partnerDetails.id,
								partner_user_id: userAccessCode,
							}
						: {}
				}
				successArgs={
					partnerDetails
						? {
								partner_id: partnerDetails?.id,
								partner_type: [partnerDetails?.category?.toLowerCase() || null],
							}
						: {}
				}
			/>
			{purchaseTerms}
		</ContentWrapper>
	);
};

export default Payment;
